'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFreemiumViralLink;

var _hubspotUrlinator = require('hubspot.urlinator.Url');

var _hubspotUrlinator2 = _interopRequireDefault(_hubspotUrlinator);

var _SignupUrlGenerator = require('signup-ui-core/SignupUrlGenerator');

var _SignupUrlGenerator2 = _interopRequireDefault(_SignupUrlGenerator);

var _SignupFlows = require('signup-ui-core/constants/SignupFlows');

var _AllowedHubs = require('signup-ui-core/constants/AllowedHubs');

var _AllowedHubs2 = _interopRequireDefault(_AllowedHubs);

var _AllowedCustomOpts = require('signup-ui-core/constants/AllowedCustomOpts');

var _AllowedCustomOpts2 = _interopRequireDefault(_AllowedCustomOpts);

var _AllowedIntents = require('signup-ui-core/constants/AllowedIntents');

var _AllowedIntents2 = _interopRequireDefault(_AllowedIntents);

var _AllowedUtms = require('signup-ui-core/constants/AllowedUtms');

var _AllowedUtms2 = _interopRequireDefault(_AllowedUtms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFreemiumViralLink(viralPage) {
  var salesUrl = new _SignupUrlGenerator2.default(_SignupFlows.SignupFlows.SALES).withHubs(_AllowedHubs2.default.HUBS_CAMPAIGN, 'hubspot-meetings-virality').withHubs(_AllowedHubs2.default.HUBS_CTA, viralPage).withUtm(_AllowedUtms2.default.UTM_MEDIUM, 'virality').withOption(_AllowedCustomOpts2.default.MEETING_SIDEBAR).withIntent(_AllowedIntents2.default.MEETINGS).getUrl();
  return new _hubspotUrlinator2.default(salesUrl, { lb: 'app' }).href;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/freemium/getFreemiumViralLink.js
// module id = 221
// module chunks = 0